<template>
  <div
    class="employee-inner employee-inner-permission"
    :class="{'employee-inner-full' : tabActive}"
  >
    <!-- <ListInfo :loadData="loadData" :setup-panel="permissionList" @open-modal="openModal($event)" /> -->

    <ListInfo :loadData="loadData" :setup-panel="decreeList" @open-detail="openDetail('decree', $event)" @open-modal="openModal($event)" />

    <ListInfo :loadData="loadData" :setup-panel="documentList" @open-detail="openDetail('document', $event)" @open-modal="openModal($event)" />
     <!-- <ListInfo :loadData="loadData" :setup-panel="documentList" @open-detail="openDetail('contract', $event)" @open-modal="openModal($event)" /> -->

    <ListInfo :loadData="loadData" :setup-panel="childOver21List" @open-detail="openDetail('family', $event)" @open-modal="openModal($event)" />

  </div>
</template>

<script>
  /* eslint-disable */
  import { defineComponent, ref, reactive, onBeforeMount, onMounted, watch, watchEffect, computed } from "vue"
  import { useRouter, useRoute } from "vue-router"
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  import axios from 'axios'
  import dayjs from 'dayjs'

  import ListInfo from "../EmployeeInfo/ListInfo.vue"

  export default {
    components: {
      ListInfo
    },

    props: {
      tabActive: { type: Boolean, default: false },
      loadData: { type: Boolean, default: false },
      thisMonthnow: { type: String, default: "" },

      expiringDecree: { type: Object, default: [] },
      expiredDecree: { type: Object, default: [] },
      expiringDecreefull: { type: Object, default: [] },
      expiredDecreefull: { type: Object, default: [] },

      expiringDoc: { type: Object, default: [] },
      expiredDoc: { type: Object, default: [] },
      expiringDocfull: { type: Object, default: [] },
      expiredDocfull: { type: Object, default: [] },

      childOver21: { type: Object, default: [] }
    },

    setup(props, { emit }) {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()
      const decreeList = ref({})
      const documentList = ref({})
      const childOver21List = ref({})


      const openDetail = (type, data) => {
        emit("open-detail", {type, data})
      }

      const openModal = (data) => {
        // console.log("cek ges", data)
        emit("open-modal", data)
      }


      onBeforeMount(() => {

      })

      onMounted(() => {

      })

      watchEffect(() => {
        if(
          props.expiringDecree ||
          props.expiredDecree ||
          props.expiringDecreefull ||
          props.expiredDecreefull
        ) {
          decreeList.value = {
            id: "decree_list_container",
            title: "Decree",
            month: null,
            child: [
              {
                id: "expiringDecree",
                title: "Is Expiring",
                container_color: 'yellow',
                dataShow: props.expiringDecree,
                dataFull: props.expiringDecreefull
              },
              {
                id: "expiredDecree",
                title: "Is Expired",
                container_color: 'red',
                dataShow: props.expiredDecree,
                dataFull: props.expiredDecreefull
              },
            ]
          }
        }

        if(
          props.expiringDoc ||
          props.expiredDoc ||
          props.expiringDocfull ||
          props.expiredDocfull
        ) {
          documentList.value = {
            id: "document_list_container",
            title: "Document",
            month: null,
            child: [
              {
                id: "expiringDoc",
                title: "Is Expiring",
                container_color: 'yellow',
                dataShow: props.expiringDoc,
                dataFull: props.expiringDocfull
              },
              {
                id: "expiredDoc",
                title: "Is Expired",
                container_color: 'red',
                dataShow: props.expiredDoc,
                dataFull: props.expiredDocfull
              },
            ]
          }
        }

         if(
          props.childOver21
        ) {
           childOver21List.value = {
            id: "document_list_container",
            title: "Child Over 21",
            month: null,
            child: [
              {
                id: "childOver21",
                title: "",
                container_color: 'yellow',
                dataShow: props.childOver21,
                dataFull: props.childOver21
              },
            ]
          }
        }
      })

      return {
        openModal,
        decreeList,
        documentList,
        childOver21List,
        openDetail
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
